'use strict';
define('elements/inquiry',['jquery'], function($) {
	// Roomtype
	$(document).ready(function () {
		// Roomtype toggle
		var $toggleSingle = $('#powermail_field_roomtype_1'),
			$toggleDouble = $('#powermail_field_roomtype_2'),
			$tripDateHandle = $('.trip-summary__date span'),
			guestHandle = 'trip-summary__price',
			priceHandle = 'trip-summary__guest',
			totalHandle = 'trip-summary__total',
			$secondPerson = $('.powermail_fieldset_29'),
			$secondPersonVegetarian = $('#powermail_field_istihrmitreisendervegetarier'),
			$tripTotal = $('#powermail_field_triptotal'),
			$tripDate = $('#powermail_field_tripdate'),

			// Inquiry toggle
			$toggleBooking = $('#powermail_field_submit_buttons_1'),
			$toggleInquiry = $('#powermail_field_submit_buttons_2'),
			$shareContact = $('#powermail_fieldwrap_108'),
			$privacyPolicy = $('#powermail_fieldwrap_197'),
			$tripGuideline = $('#powermail_fieldwrap_203'),
			$tripWarning = $('#powermail_fieldwrap_270'),
			$tripCovid = $('#powermail_fieldwrap_271'),
			$AGB = $('#powermail_fieldwrap_109'),
			$submitButton = $('#powermail_fieldwrap_47');

		if($('.' + totalHandle).length > 0) {
			var totalValueSingle = $('.' + totalHandle + '--single span').text(),
				totalValueDouble = $('.' + totalHandle + '--double span').text();
		}
		if($tripDateHandle.length > 0) {
			var tripDateValue = $tripDateHandle.text();
			$tripDate.val(tripDateValue);
		}
		$toggleSingle.change(function() {
			if($toggleSingle.prop('checked', true)) {
				$('.' + guestHandle).removeClass('is-visible');
				$('.' + priceHandle).removeClass('is-visible');
				$('.' + totalHandle).removeClass('is-visible');
				$secondPerson.removeClass('is-visible');

				$('.' + guestHandle + '--single').addClass('is-visible');
				$('.' + priceHandle + '--single').addClass('is-visible');
				$('.' + totalHandle + '--single').addClass('is-visible');
				$tripTotal.val(totalValueSingle).trigger('change');
				$secondPersonVegetarian.val('').trigger('change');
			}
		});

		$toggleDouble.change(function() {
			if($toggleDouble.prop('checked', true)) {
				$('.' + guestHandle).removeClass('is-visible');
				$('.' + priceHandle).removeClass('is-visible');
				$('.' + totalHandle).removeClass('is-visible');
				$secondPerson.removeClass('is-visible');

				$('.' + guestHandle + '--double').addClass('is-visible');
				$('.' + priceHandle + '--double').addClass('is-visible');
				$('.' + totalHandle + '--double').addClass('is-visible');
				$secondPerson.addClass('is-visible');
				$tripTotal.val(totalValueDouble).trigger('change');
			}
		});

		// Inquiry
        $toggleBooking.change(function() {
        	if($toggleBooking.prop('checked', true)) {
                $shareContact.addClass('is-visible');
                $AGB.addClass('is-visible');
                $privacyPolicy.addClass('is-visible');
                $tripGuideline.addClass('is-visible');
                $tripWarning.addClass('is-visible');
                $tripCovid.addClass('is-visible');
                $submitButton.addClass('is-visible');
			}
		});

        $toggleInquiry.change(function() {
            if($toggleInquiry.prop('checked', true)) {
                $shareContact.removeClass('is-visible');
                $AGB.removeClass('is-visible');
                $privacyPolicy.addClass('is-visible');
                $tripGuideline.addClass('is-visible');
				$tripWarning.addClass('is-visible');
				$tripCovid.addClass('is-visible');
                $submitButton.addClass('is-visible');
            }
        });
	});
});

